// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JobTitleDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class JobTitleApiClient extends BaseCRUDApiClient<JobTitleDto> {
  baseUrl = this.config.apiEndpoint + '/job-title';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
